var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
export const useCaseListFetchEvent = (options) => {
    const { changeCaseListPageData, fetchCaseListPageData, getReplaceUrl } = options;
    const history = useNavigate();
    /**
     * 次のページのデータを取得
     * @description 「もっと見る」ボタン押下時の処理
     */
    const onChangeNextPage = useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        const { value: nexPage } = event.currentTarget;
        const { param, url } = getReplaceUrl();
        yield fetchCaseListPageData(url, param, parseInt(nexPage, 10));
    }), [fetchCaseListPageData, getReplaceUrl]);
    /**
     * カテゴリー変更時の処理
     * @description カテゴリーの選択、解除時の処理 + 絞り込みされた一覧データの取得
     * @param value 選択されたカテゴリーの値
     */
    const onChangeSelectingCategory = useCallback((value) => __awaiter(void 0, void 0, void 0, function* () {
        // 新しいパラメータの値, URL を取得
        const { param, url } = getReplaceUrl((prevQueryParams) => {
            const prevCategory = parseInt((prevQueryParams === null || prevQueryParams === void 0 ? void 0 : prevQueryParams.category) || '', 10);
            return Object.assign(Object.assign({}, prevQueryParams), { 
                // 現在のカテゴリーが同じ値の場合 値を削除（選択解除）
                category: prevCategory === value ? undefined : value.toString() });
        });
        // state 初期化, URL 更新
        history.replace(url);
        changeCaseListPageData({
            caseListData: [],
            currentPage: 0,
            isLastPage: false,
        });
        // 一覧データ取得
        yield fetchCaseListPageData(url, param);
    }), [changeCaseListPageData, fetchCaseListPageData, getReplaceUrl, history]);
    /**
     * 金額変更時の処理
     * @description 金額の選択、解除時の処理 + 絞り込みされた一覧データの取得
     * @param value 選択された金額の値
     */
    const onChangeSelectingPrices = useCallback((value) => __awaiter(void 0, void 0, void 0, function* () {
        // 新しいパラメータの値, URL を取得
        const { param, url } = getReplaceUrl((prevQueryParams) => (Object.assign(Object.assign({}, prevQueryParams), { price: value.join(',') })));
        // state 初期化, URL 更新
        history.replace(url);
        changeCaseListPageData({
            caseListData: [],
            currentPage: 0,
            isLastPage: false,
        });
        // 一覧データ取得
        yield fetchCaseListPageData(url, param);
    }), [changeCaseListPageData, fetchCaseListPageData, getReplaceUrl, history]);
    return {
        onChangeNextPage,
        onChangeSelectingCategory,
        onChangeSelectingPrices,
    };
};
